import { MapType, TimeMode } from './store';

export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoicmFjZW1hcCIsImEiOiJjam01NW1tN2cwZnNvM3R1bHltYzRxemZ4In0.W0M3Y8xMcU0YWWcQ7twZ9A';
export const MAP_STYLES = [
  { label: MapType.TERRAIN, key: 'outdoors-v11' },
  { label: MapType.SATELLITE, key: 'satellite-v9' },
  { label: MapType.HYBRID, key: 'satellite-streets-v11' },
  { label: MapType.ROADMAP, key: 'streets-v11' },
  { label: MapType.DARK, key: 'dark-v10' },
];

export const TIME_MODES: Array<TimeMode> = [TimeMode.RELATIVE, TimeMode.ABSOLUTE];

export const TILE_WIDTH = 256;
function listenOnDevicePixelRatio() {
  function onChange() {
    listenOnDevicePixelRatio();
  }

  if (typeof window === 'undefined' || !window.matchMedia) return;

  matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`).addEventListener('change', onChange, {
    once: true,
  });
}
listenOnDevicePixelRatio();
export const DEVICE_PIXEL_RATIO = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;
export type WebGLContext = WebGLRenderingContext | WebGL2RenderingContext;

export type Tuple2 = [number, number];
export type Tuple3 = [number, number, number];
export type Tuple4 = [number, number, number, number];

export const MAX_PARTICLES = 1000;
export const MAX_STARTER_COUNT_FLAG = 1000;

export const DEFAULT_POI_COLOR = '#ffffff';

export const FONT_SIZE = '12px';
export const FONT_STYLE = 'bold';
export const FONT_FAMILY = '"Helvetica Neue", Helvetica, Arial, sans-serif';
export const FONT = `${FONT_STYLE} ${FONT_SIZE} ${FONT_FAMILY}`;
export const BASE_BLUE = '#36739a';
export const DARK_GREY = '#444444';

export const SHADOW_TRACK_STEP = 10; // meters
export const STATISTIC_FILTER_SIZE = 30; // * SHADOW_TRACK_STEP
export const JUMP_SPEED_THRESHOLD = 200 / 3600; // 200km/h => in m/ms

// Times
export const SECONDS = 1000;
export const MINUTES = 60 * SECONDS;
export const HOURS = 60 * MINUTES;
export const DAYS = 24 * HOURS;

export const NULL_TAG = '--null--';
export const ALL_TAG = '--all--';
